const openPressRoomVideoPopup = () => {
  const pressRoomVideoPopup = document.getElementById('press-room-how-nomad-works-video-popup')

  pressRoomVideoPopup.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')

  pressRoomVideoPopup.style.display = 'flex';
}

const closePressRoomVideoPopup = () => {
  const pressRoomVideoPopup = document.getElementById('press-room-how-nomad-works-video-popup')

  pressRoomVideoPopup.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')

  pressRoomVideoPopup.style.display = 'none';
}

window.addEventListener('DOMContentLoaded', () => {
  const pressRoomVideoPlayButtons = document.querySelectorAll('.press-room-how-nomad-works-video-play-button');

  pressRoomVideoPlayButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      openPressRoomVideoPopup();
    })
  })

  const pressRoomVideoPopup = document.getElementById('press-room-how-nomad-works-video-popup')

  pressRoomVideoPopup.addEventListener('click', () => {
    closePressRoomVideoPopup();
  })

  const pressRoomVideoPopupContent = document.getElementById('press-room-how-nomad-works-video-popup-content')

  pressRoomVideoPopup.addEventListener('click', (e) => {
    e.stopPropagation();
  })
})
